import { useState, useEffect } from "react";

const PHG_LOGO = "/images/phg-logo.png";
const CDBJJ_LOGO = "/images/carpe2.png";

export default function CdbjjNav() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const links = [
    { label: "Collection", href: "#products" },
    { label: "Rash.G L/S", href: "#product-rush-ls" },
    { label: "Rash.G H/S", href: "#product-rush-ss" },
    { label: "Fight Shorts", href: "#product-fight-shorts" },
    { label: "Tee", href: "#product-tee" },
  ];

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? "bg-black/95 border-b border-white/10 backdrop-blur-sm" : "bg-transparent"
      }`}
    >
      <div className="w-full px-6 md:px-10 h-16 flex items-center justify-between">

        {/* Left: CDBJJ Logo */}
        <a
          href="#"
          className="flex items-center cursor-pointer"
          onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: "smooth" }); }}
        >
          <div className="w-10 h-10 flex items-center justify-center">
            <img src={CDBJJ_LOGO} alt="Carpe Diem BJJ" className="w-full h-full object-contain" />
          </div>
        </a>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.label}
              href={l.href}
              className="text-white/55 text-sm tracking-wider uppercase hover:text-white transition-colors whitespace-nowrap cursor-pointer"
            >
              {l.label}
            </a>
          ))}
        </nav>

        {/* Right: PHG Logo */}
        <div className="hidden md:flex items-center gap-3">
          <span className="text-white/35 text-xs tracking-widest uppercase whitespace-nowrap">2026 Collection</span>
          <div className="w-1.5 h-1.5 bg-red-600 rounded-full" />
          <a
            href="https://dssr-co.info/powerhouse"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center cursor-pointer"
          >
            <div className="w-9 h-9 flex items-center justify-center">
              <img src={PHG_LOGO} alt="Powerhouse Gym" className="w-full h-full object-contain" />
            </div>
          </a>
        </div>

        {/* Hamburger */}
        <button
          className="md:hidden w-8 h-8 flex items-center justify-center text-white cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="メニュー"
        >
          <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="md:hidden bg-black/98 border-t border-white/10 px-6 py-6 flex flex-col gap-5">
          {links.map((l) => (
            <a
              key={l.label}
              href={l.href}
              onClick={() => setMenuOpen(false)}
              className="text-white/60 text-sm tracking-widest uppercase hover:text-white transition-colors whitespace-nowrap cursor-pointer"
            >
              {l.label}
            </a>
          ))}
        </div>
      )}
    </header>
  );
}
